// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-title {
    color: #c4bfbf;
    font-size: 16px;
    font-weight: 500;
}

.title {
    font-size: 14px;
    font-weight: 700;
    padding-left: 1%;

}`, "",{"version":3,"sources":["webpack://./src/features/commandes/components/customOrderStyle.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;;AAEpB","sourcesContent":[".label-title {\n    color: #c4bfbf;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.title {\n    font-size: 14px;\n    font-weight: 700;\n    padding-left: 1%;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
